import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet'
import PrettyJsonRenderer from '@/components/PrettyJsonRenderer.vue'

interface Props {
  open?: boolean;
  data?: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ReqRespPreviewSheet',
  props: {
    open: { type: Boolean, default: false },
    data: { default: () => [] }
  },
  emits: ["update:open"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const handleClose = () => {
  emit('update:open', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Sheet), {
    open: props.open,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => (emit('update:open', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(SheetContent), { class: "w-1/2 overflow-hidden flex flex-col bg-slate-100" }, {
        default: _withCtx(() => [
          _createVNode(_unref(SheetHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(SheetTitle), null, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Preview", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(SheetDescription), { class: "flex-1 overflow-y-auto bg-slate-50 rounded-md p-4" }, {
            default: _withCtx(() => [
              _createVNode(PrettyJsonRenderer, {
                data: props.data
              }, null, 8, ["data"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})